import React from 'react';
import { Mountain } from 'lucide-react';
export function Footer() {
  return <footer className="bg-forest-900 text-earth-100 py-16" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-28">
          <div className="col-span-1 md:col-span-2" data-id="element-29">
            <div className="flex items-center gap-2 mb-6" data-id="element-30">
              <Mountain className="w-8 h-8 text-sunset-600" data-id="element-31" />
              <span className="text-2xl font-serif font-bold text-white" data-id="element-32">
                Fableworld
              </span>
            </div>
            <p className="text-earth-200 max-w-sm mb-6" data-id="element-33">
              Connecting souls with the soil since 2024. We are dedicated to
              sustainable hiking and community building in the heart of Hungary.
            </p>
            <address className="not-italic text-earth-200" data-id="element-34">
              Kerepesi út 9<br data-id="element-35" />
              1087 Budapest
              <br data-id="element-36" />
              Hungary
            </address>
          </div>

          <div data-id="element-37">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-38">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-39">
              <li data-id="element-40">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-41">
                  Our Story
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-43">
                  Trail Groups
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-45">
                  Calendar
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-47">
                  Membership
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-48">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-49">
              Legal
            </h4>
            <ul className="space-y-4" data-id="element-50">
              <li data-id="element-51">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-52">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-54">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-sunset-500 transition-colors" data-id="element-56">
                  Waiver
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-forest-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-57">
          <p className="text-sm text-earth-400" data-id="element-58">
            © 2026 Fableworld. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-59">
            {/* Social icons placeholder */}
            <div className="w-6 h-6 bg-forest-800 rounded-full hover:bg-sunset-600 transition-colors cursor-pointer" data-id="element-60" />
            <div className="w-6 h-6 bg-forest-800 rounded-full hover:bg-sunset-600 transition-colors cursor-pointer" data-id="element-61" />
            <div className="w-6 h-6 bg-forest-800 rounded-full hover:bg-sunset-600 transition-colors cursor-pointer" data-id="element-62" />
          </div>
        </div>
      </div>
    </footer>;
}